import { useEffect } from "react";
import { fetchBranches } from "../data/api";

const SITE = "https://shreesiddhivinayakvadapav.com";

// Injects LocalBusiness/Restaurant structured data for every branch (with geo)
// so each outlet can appear in Google Search & Maps.
export const SeoBranches = () => {
  useEffect(() => {
    let scriptEl;
    fetchBranches()
      .then((branches) => {
        if (!Array.isArray(branches) || branches.length === 0) return;
        const prev = document.getElementById("ssv-branches-jsonld");
        if (prev) prev.remove();
        const graph = branches.map((b) => ({
          "@type": "Restaurant",
          "@id": `${SITE}/#branch-${b.slug}`,
          name: `Shree Siddhivinayak Vada Pav — ${b.name}`,
          image: `${SITE}/images/vadapav.png`,
          servesCuisine: ["Maharashtrian", "Indian Street Food", "Vada Pav", "Snacks"],
          priceRange: "₹",
          url: SITE,
          openingHours: "Mo-Su 05:00-22:00",
          address: {
            "@type": "PostalAddress",
            streetAddress: b.address,
            addressLocality: "Pimpri-Chinchwad",
            addressRegion: "Maharashtra",
            addressCountry: "IN",
          },
          geo: { "@type": "GeoCoordinates", latitude: b.lat, longitude: b.lng },
        }));
        scriptEl = document.createElement("script");
        scriptEl.type = "application/ld+json";
        scriptEl.id = "ssv-branches-jsonld";
        scriptEl.text = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
        document.head.appendChild(scriptEl);
      })
      .catch(() => {});
    return () => {
      const existing = document.getElementById("ssv-branches-jsonld");
      if (existing) existing.remove();
    };
  }, []);
  return null;
};
